// Messages for API validation errors sent as { code, values }, see components/notifications/Alerts
export const errorMessages = {
  previousBedAssigned:
    'This census entry cannot be deleted. Deleting it would move the resident back to {{facility}}, suite {{suite}}, bed {{bed}}, which is now assigned to another resident. Free up the bed first, then try again.',
  censusFieldsLocked: 'Census {{fields}} cannot be changed by an edit',
  residentRefFormat: 'Resident ID must be the facility abbreviation followed by at least 3 digits, e.g. AG001',
  unitChangeKeepsStatus:
    "A Unit Change keeps the resident's current status. Use Leave, Return From Leave or Leave Status Change to change it.",
  stopBillingDateRequired: 'Stop billing date is required for a Move Out',
  stopBillingBeforeMoveOut: 'The stop billing date cannot be before the Move Out date',
  stopBillingAfterNextEntry: 'The stop billing date must be before the next census entry',
  rateAfterMoveOut: "This rate starts after the resident's Move Out. Add a Move In first, then the rate."
}
